module.exports = __webpack_public_path__ + "static/media/semAgrupamentos.ae98cdca.PNG";